<template>
  <full-width>
    <back-button />
    <h2
      class="text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
    >
      Pre-order Additional Masks
    </h2>
    <!-- PO Container -->
    <div class="max-w-xl mx-auto mt-8">
      <!-- Header -->
      <div
        class="flex justify-between px-4 py-2 text-white bg-gray-400 md:px-3"
      >
        <h2 class="flex-1">Description</h2>
        <div class="flex justify-end">
          <h2 class="text-left w-36">Quantity</h2>
          <h2 class="w-20 text-right">Amount</h2>
        </div>
      </div>
      <!-- SKU Items -->
      <div
        v-for="(product, index) in products"
        :key="index"
        :class="index === products.length - 1 ? 'border-b-0' : 'border-b'"
        class="flex flex-col py-6 mx-3 tmsk-blue-text tmsk-blue-border"
      >
        <div class="flex flex-row items-center justify-between">
          <div
            class="flex flex-col items-start space-y-0 md:space-x-2 md:items-center md:flex-row md:space-x-0 md:space-y-2"
          >
            <div class="w-20 sm:w-48">
              <img
                v-if="product.enabled"
                :src="product.imageUrl"
                :alt="product.name"
                class="w-full"
              />
              <img
                v-else
                :src="product.imageUrl"
                :alt="product.name"
                class="w-full"
              />
            </div>
            <span
              class="hidden w-full text-lg font-bold text-left tmsk-blue-text md:pl-0 md:block"
            >
              {{ product.name }}
            </span>
            <!-- <div class="items-center block md:flex">
            <img :src="require(`@/assets/img/masksOnly/${product.imageUrl}`)" :alt="product.name"
              class="w-4/5 md:w-2/5" />
            <h2 class="w-4/5 text-lg font-bold text-center tmsk-blue-text md:w-2/5">{{ product.name }}</h2>
          </div> -->
          </div>
          <div class="flex items-end space-x-2 md:space-x-4">
            <!-- Quantity -->
            <div v-if="product.enabled" class="flex items-end w-32 space-x-2">
              <button
                type="button"
                :class="
                  !purchasing[product.sku] && 'opacity-50 cursor-not-allowed'
                "
                class="text-base font-medium leading-6 border border-transparent focus:outline-none"
                @click="handleChangeQty('-', product)"
              >
                <p
                  class="flex items-center justify-center w-10 h-10 text-xl bg-gray-100 rounded-full tmsk-blue-text"
                >
                  <svg
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    class="w-6 h-6 minus"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </p>
              </button>
              <p
                class="flex items-center justify-center w-10 h-10 text-xl font-bold tmsk-blue-text"
              >
                {{ purchasing[product.sku] || 0 }}
              </p>
              <button
                type="button"
                :class="
                  purchasing[product.sku] === quotas[product.sku] &&
                  'opacity-50 cursor-not-allowed'
                "
                class="z-10 text-base font-medium leading-6 border border-transparent focus:outline-none"
                @click="handleChangeQty('+', product)"
              >
                <p
                  class="flex items-center justify-center w-10 h-10 text-lg bg-gray-100 rounded-full tmsk-blue-text"
                >
                  <svg
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    class="w-6 h-6 plus"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </p>
              </button>
            </div>
            <!-- Amount -->
            <p
              v-if="product.enabled"
              class="w-20 py-2 text-xl font-bold text-right"
            >
              <!-- qty * price -->
              ${{
                !purchasing[product.sku]
                  ? "0.00"
                  : (purchasing[product.sku] * product.price).toFixed(2)
              }}
            </p>
          </div>
        </div>
        <!-- Item Details -->
        <div class="w-full">
          <span
            class="block w-full mt-4 text-lg font-bold text-left tmsk-blue-text md:pl-0 md:hidden"
          >
            {{ product.name }}
          </span>
          <p class="mt-1" data-e2e-attr="purchase-price-rrp">
            Price: ${{ product.price.toFixed(2) }}/mask (RRP: ${{product.rrp.toFixed(2)}}/mask)
          </p>
          <ul class="list-disc list-inside">
            <li v-for="(note, index) in product.notes" :key="index">
              {{ note.desc }}
            </li>
          </ul>
          <!-- Colllect modes -->
          <div class="flex items-center mt-4">
            <p class="flex items-center">
              <svg
                v-if="product.collectionMethod.freeCollection"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-4 h-4 m-auto mr-1 check"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <svg
                v-else
                viewBox="0 0 20 20"
                fill="red"
                class="w-4 h-4 m-auto mr-1 text-red-600 x"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              Free collection
            </p>
            <p class="flex items-center ml-1 md:ml-3">
              <svg
                v-if="product.collectionMethod.preOrder"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-4 h-4 m-auto mr-1 check"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <svg
                v-else
                viewBox="0 0 20 20"
                fill="red"
                class="w-4 h-4 m-auto mr-1 text-red-600 x"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              Pre-order more
            </p>
            <tooltip height="h-auto" margin="ml-1">
              <p data-e2e-attr="purchase-tooltip" >Pre-order period: {{ preOrderPeriod }}</p>
              <p data-e2e-attr="purchase-tooltip">Collection period: {{ collectionPeriod }}</p>
              <p class="mt-4" data-e2e-attr="purchase-tooltip">
                No refunds or exchanges after collection for hygiene reasons. Find out what is your mask size
                <a
                  class="font-bold underline cursor-pointer"
                  href="http://stayprepared.sg/sizing-guide"
                  target="_blank"
                  >here</a
                >.
              </p>
              <p class="mt-4" >
                For details on free mask collection eligibility, pre-order quota
                and locations, click
                <a
                  data-e2e-attr="purchase-tooltip"
                  class="font-bold underline cursor-pointer"
                  :href="cheatSheetUrl"
                  target="_blank"
                  >here</a
                >.
              </p>
            </tooltip>
          </div>
          <div v-if="product.enabled" class="flex items-center my-2">
            <p>My Available Quota:</p>
            <p
              class="flex items-center justify-center w-10 h-10 ml-4 text-lg font-bold bg-white border-2 border-teal-400 rounded-full tmsk-blue-text"
            >
              <!-- {{ quotas[0].quota }} <br/> -->
              <!-- {{ quotas.find((item) => product.sku === item.sku).quota }} -->
              {{ quotas[product.sku] - (purchasing[product.sku] || 0) }}
            </p>
          </div>
          <p data-e2e-attr="purchase-collect-at">
            Collect at:
            <span class="font-bold">{{ product.description }}</span>
            <tooltip height="h-auto" margin="ml-1">
              <p data-e2e-attr="purchase-locatevending-tooltip">
                To find out where this mask is available for collection, select <a
                  class="font-bold underline cursor-pointer"
                  @click="routeToLocateVM(product.sku)"
                  >'Locate Vending Machine'</a> in the menu bar.</p>
            </tooltip>
          </p>
          <p class="text-red-600">
            Please choose the right size (see sizing guide
            <a
              class="underline"
              href="http://stayprepared.sg/sizing-guide"
              target="_blank"
              >here</a
            >). No refunds or exchanges after collection for hygiene reasons.
          </p>
        </div>
      </div>
      <!-- end SKU items -->
      <div class="p-3 text-center tmsk-blue-bg">
        <h2 class="text-lg tracking-wide text-white">
          Subtotal: ${{ totalAmount.toFixed(2) }}
        </h2>
      </div>
      <p
        v-if="purchaseValid === false"
        class="mt-6 text-sm text-center text-red-600"
      >
        Please select your order quantity.
      </p>
      <!-- Actions -->
      <div class="flex justify-center mt-6">
        <button
          type="button"
          @click="handleClearCart"
          class="p-3 text-white rounded-full tmsk-blue-bg w-28"
        >
          Clear
        </button>
        <button
          data-e2e-attr="purchase-post-checkout-button"
          type="button"
          @click="handleCheckout"
          class="p-3 ml-4 text-white rounded-full tmsk-blue-bg w-28"
        >
          Checkout
        </button>
        <!-- <button type="button" @click="handleCheckout"
          :class="isPayLahTile ? 'w-auto' : 'w-24'"
          class="p-4 ml-4 text-white rounded-md tmsk-blue-bg">
          {{ isPayLahTile ? "Pay with PayLah!" : "Pay" }}
        </button> -->
      </div>
    </div>
    <modal
      :displayModal="displayModal"
      :displayShade="displayModal"
      @hide-all="displayModal = false"
      @show-modal="displayModal = true"
    >
      <div
        v-if="totalAmount > 0"
        class="p-4 py-4 -mt-6 text-center tmsk-blue-text md:px-6"
      >
        <!-- <h1 class="text-2xl font-bold">Important Notice</h1> -->
        <p class="text-red-600 underline" data-e2e-attr="purchase-post-checkout-popup">No refunds or exchanges</p>
        <p class="text-red-600" data-e2e-attr="purchase-post-checkout-popup">after collection for hygiene reasons.</p>
        <p class="mt-4" data-e2e-attr="purchase-post-checkout-popup">
          Do check that you have selected the correct size(s) before checkout. Refer to the sizing guide
          <a
            class="font-bold underline cursor-pointer"
            href="http://stayprepared.sg/sizing-guide"
            target="_blank"
          >
            here</a
          >.
        </p>
        <div class="flex justify-center mt-8">
          <div class="w-full mr-1 -mx-1 md:w-1/2">
            <button
              @click="displayModal = false"
              class="px-10 py-2 text-white rounded-full tmsk-blue-bg md:px-15"
            >
              Cancel
            </button>
          </div>
          <div class="w-full ml-1 -mx-1 md:w-1/2">
            <button
              @click="handleProceedCheckout"
              class="px-10 py-2 text-white rounded-full tmsk-blue-bg md:px-15"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </modal>
  </full-width>
</template>

<script>
// import Card from '@/components/Card'
import Tooltip from '../../components/Tooltip'
import beepAPI from '../../mixins/beepAPI'
import FullWidth from '../../components/Layout/FullWidth'
import BackButton from '../../components/BackButton'
import Modal from '../../components/Modal'
import { PREORDER_PERIOD, COLLECTION_PERIOD, CHEATSHEET_URL } from '../../Constants'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
export default {
  name: 'Purchase',
  metaInfo () {
    return {
      title: 'Pre-order Additional Masks',
      // meta: [
      //   { property: 'og:title', content: 'Pre-order Additional Masks' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: '/Pre-order Additional Masks' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-04.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    // Card,
    Tooltip,
    FullWidth,
    BackButton,
    Modal
  },
  mixins: [beepAPI],
  props: {},
  data () {
    return {
      purchaseValid: null,
      displayModal: false,
      throttleTimeout: null
    }
  },
  computed: {
    ...mapState(['products', 'quotas', 'purchasing', 'isPayLahTile', 'payLahTileData', 'isLoggedIn']),
    ...mapGetters(['totalAmount'])
    // quota () {
    // return this.quotas.find(item => item.sku === sku)
    // return {
    //   adult_white: 1,
    //   kids_white: 2,
    //   adult_black: 3,
    //   kids_black: 4,
    //   adult_denim: 5
    // }
    // return this.quotas.find(item => ite)
    // }
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {
    this.preOrderPeriod = PREORDER_PERIOD
    this.collectionPeriod = COLLECTION_PERIOD
    this.cheatSheetUrl = CHEATSHEET_URL
  },
  beforeMount () {},
  mounted () {
    if (this.isLoggedIn) {
      this.handleLoadPage()
      this.resetAfterSuccessfulPurchase()
    } else {
      this.$router.push({ name: 'Login', query: this.$route.query })
    }
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateProducts', 'updatePurchasing', 'updateTransactionHistory', 'updateQuotas']),
    ...mapMutations(['resetAfterSuccessfulPurchase', 'setFilteredPurchasing', 'setPurchasing']),
    handleChangeQty (type, product) {
      const remaining = this.quotas[product.sku]
      const qty = this.purchasing[product.sku] || 0

      switch (type) {
        case '+':
          if (qty < remaining) {
            this.setPurchasing({ sku: product.sku, qty: qty + 1 })
          }
          break
        case '-':
          if (qty > 0) {
            this.setPurchasing({ sku: product.sku, qty: qty - 1 })
          }
          break
      }

      const body = {
        items: Object.entries(this.purchasing)
          .map(([sku, qty]) => {
            return {
              sku: sku,
              quantity: qty
            }
          })
      }

      if (this.throttleTimeout) {
        clearTimeout(this.throttleTimeout)
        this.throttleTimeout = null
      }

      this.throttleTimeout = setTimeout(() => {
        this.putCart(body)
          .catch(console.error)
      }, 750)
    },

    handleClearCart () {
      // using this function to reset cart
      this.resetAfterSuccessfulPurchase()

      const body = {
        items: Object.entries(this.purchasing)
          .map(([sku, qty]) => {
            return {
              sku: sku,
              quantity: qty
            }
          })
      }
      this.putCart(body)
        .catch(console.error)
    },

    handleCheckout () {
      if (this.totalAmount > 0) {
        this.purchaseValid = true
        this.displayModal = true
      } else {
        this.purchaseValid = false
      }
    },

    async handleProceedCheckout () {
      const filteredPurchasing = this.purchasing
      Object.keys(filteredPurchasing).map(sku => {
        const qty = filteredPurchasing[sku]
        if (qty === 0) {
          delete filteredPurchasing[sku]
        }
      })

      await this.setFilteredPurchasing(filteredPurchasing)

      const body = {
        items: Object.entries(this.purchasing)
          .map(([sku, qty]) => {
            return {
              sku: sku,
              quantity: qty
            }
          })
      }
      this.putCart(body)
        .catch(console.error)

      if (this.totalAmount > 0) {
        this.purchaseValid = true
        if (this.isPayLahTile) {
          // this.$router.push({ name: 'Checkout', query: { ...this.payLahTileData, ...this.$route.query } })
          this.$router.push({ name: 'Checkout', query: this.$route.query })
        } else {
          this.$router.push({ name: 'Checkout', query: this.$route.query })
        }
      } else {
        this.purchaseValid = false
      }
    },

    handleFetchProducts () {
      return new Promise((resolve, reject) => {
        this.getProducts()
          .then(
            response => {
              this.updateProducts(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch products.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchTransactionHistory () {
      return new Promise((resolve, reject) => {
        this.getTransactionHistory()
          .then(
            response => {
              this.updateTransactionHistory(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch transaction history.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchQuotas () {
      return new Promise((resolve, reject) => {
        this.getQuotas()
          .then(
            response => {
              this.updateQuotas(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch product quotas.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchCart () {
      return new Promise((resolve, reject) => {
        this.getCart()
          .then(
            async response => {
              for await (const { sku, quantity } of response) {
                const quota = this.quotas[sku]
                if (quantity > quota) {
                  this.updatePurchasing({ sku, qty: quota })
                } else {
                  this.updatePurchasing({ sku: sku, qty: quantity })
                }
              }

              resolve(response)
            },
            error => {
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch cart.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleLoadPage () {
      this.setIsLoading(true)

      Promise.all([
        // this.handleFetchTransactionHistory(),
        this.handleFetchProducts(),
        this.handleFetchQuotas()
      ])
        .then(
          async result => {
            await this.handleFetchCart()
            this.setIsLoading(false)
          },
          () => {
            this.$router.push({ name: 'Home', query: this.$route.query })
            this.setIsLoading(false)
          }
        )
    },

    routeToLocateVM (sku) {
      this.$router.push({ path: `/locate-vending-machines/${sku}` })
    }
  }
}
</script>

<style scoped>
</style>
